/**
 * Mixin methods that handle vuex chat room actions (close, invite, leave ...)
 */

export default {
  name: 'mixin-chat-helper',
  methods: {
    capitalizeFirstLetter (string) {
      return string?.charAt(0).toUpperCase() + string?.slice(1)
    },

    getCurrentRoomTypeForUrl (type) {
      if (type === 'c') {
        return 'channel'
      } else if (type === 'p') {
        return 'group'
      } else if (type === 'd') {
        return 'direct'
      } else {
        return null
      }
    },

    isAudio (type) {
      return type?.includes('audio')
    },

    isImage (type) {
      return type?.includes('image')
    },

    isVideo (type) {
      return type?.includes('video')
    },

    /**
     * Human readable elapsed or remaining time (example: 3 minutes ago)
     * @param  {Date|Number|String} date A Date object, timestamp or string parsable with Date.parse()
     * @param  {Date|Number|String} [nowDate] A Date object, timestamp or string parsable with Date.parse()
     * @param  {Intl.RelativeTimeFormat} [trf] A Intl formater
     * @return {string} Human readable elapsed or remaining time
    */
    fromNow (date, nowDate = Date.now(), rft = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' })) {
      const SECOND = 1000
      const MINUTE = 60 * SECOND
      const HOUR = 60 * MINUTE
      const DAY = 24 * HOUR
      const WEEK = 7 * DAY
      const MONTH = 30 * DAY
      const YEAR = 365 * DAY
      const intervals = [
        { ge: YEAR, divisor: YEAR, unit: 'year' },
        { ge: MONTH, divisor: MONTH, unit: 'month' },
        { ge: WEEK, divisor: WEEK, unit: 'week' },
        { ge: DAY, divisor: DAY, unit: 'day' },
        { ge: HOUR, divisor: HOUR, unit: 'hour' },
        { ge: MINUTE, divisor: MINUTE, unit: 'minute' },
        { ge: 30 * SECOND, divisor: SECOND, unit: 'seconds' },
        { ge: 0, divisor: 1, text: 'just now' }
      ]
      const now = typeof nowDate === 'object' ? nowDate.getTime() : new Date(nowDate).getTime()
      const diff = now - (typeof date === 'object' ? date : new Date(date)).getTime()
      const diffAbs = Math.abs(diff)
      for (const interval of intervals) {
        if (diffAbs >= interval.ge) {
          const x = Math.round(Math.abs(diff) / interval.divisor)
          const isFuture = diff < 0
          const text = interval.unit ? rft.format(isFuture ? x : -x, interval.unit) : interval.text
          return { interval: interval, number: x, text: text }
        }
      }
    }
  }
}
